export default __webpack_public_path__ + "static/media/bg4_1_m.9cbff4f5.png";